


































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Problem extends Vue {
  private feedBackForm: any = {
    suggestDesc: "",
    suggestType: "",
    suggestPhone: "",
    suggestWeChat: "",
  };
  private feedBackInfo: any = null;
  /**
   * 问题反馈表单
   */
  private async submitForm() {
    // console.log("feedBackForm", this.feedBackForm);
    if (!this.feedBackForm.suggestDesc) {
      this.$message.warning("请填写您的意见/建议");
      return;
    }
    if (!this.feedBackForm.suggestType) {
      this.$message.warning("请选择您的意见/建议类型");
      return;
    }
    this.feedBackInfo = await this.$apis.saveOrUpdateFeedBack(
      this.feedBackForm
    );
    this.$message({
      message: "提交成功，感谢您的建议！",
      type: "success",
    });
  }
}
